import { accessTokenAtom } from "@/atoms/authAtoms";
import { authStore } from "@/stores/auth.store";
import { authPaths, withoutMasterLoginPaths } from "@/utils/publicRoutes";
import { ZodLocalStorage } from "@/utils/ZodLocalStorage";
import { z } from "zod";
import { shouldSkipAccessToken } from "./skipAccessToken";

const clearAccessTokenHeader = (config: any) => {
	const headers = config.headers;
	if (!headers) return;
	if (typeof headers.delete === "function") {
		headers.delete("x-access-token");
		return;
	}
	delete headers["x-access-token"];
};

const onRequest = async (config: any) => {
	const url = config.url;

	if (withoutMasterLoginPaths.some((path) => url?.startsWith(path))) {
		return config;
	}

	if (authPaths.some((path) => url?.startsWith(path))) {
		return config;
	}

	if (config.skipAccessToken || shouldSkipAccessToken(url)) {
		clearAccessTokenHeader(config);
		return config;
	}

	const storage = new ZodLocalStorage({
		accessToken: z.string().min(1),
	});

	const isAccessTokenAvailable = storage.getItem("accessToken");
	let accessToken = isAccessTokenAvailable.success ? isAccessTokenAvailable.data : undefined;

	authStore.sub(accessTokenAtom, () => {
		accessToken = authStore.get(accessTokenAtom);
	});

	if (accessToken) {
		config.headers["x-access-token"] = accessToken;
	}
	return config;
};

const onRequestError = (error: any) => {
	return Promise.reject(error);
};

const request = { onRequest, onRequestError };

export default request;
